// extracted by mini-css-extract-plugin
module.exports = {"bookmark":"BookmarkButton_bookmark__2KL20","isBookmark":"BookmarkButton_isBookmark__23AxR","status":"BookmarkButton_status__f0S0F"};